import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Message, SelectItem } from 'primeng/api';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { PlanoContaEmpresa } from 'src/app/admihair/api/dto/plano-conta-empresa.';
import { PlanoContaGrupo } from 'src/app/admihair/api/dto/plano-conta-grupo';
import { PlanoContaMatriz } from 'src/app/admihair/api/dto/plano-conta-matriz';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { PlanoContaEmpresaService } from 'src/app/admihair/service/plano-conta-empresa.service';
import { PlanoContaGrupoService } from 'src/app/admihair/service/plano-conta-grupo.service';
import { PlanoContaMatrizService } from 'src/app/admihair/service/plano-conta-matriz.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';

@Component({
  selector: 'app-plano-conta-empresa-inserir',
  templateUrl: './plano-contas-empresa-inserir.component.html',
  styleUrls: ['./plano-contas-empresa-inserir.component.scss']
})
export class PlanoContaEmpresaInserirComponent implements OnInit {

  messages: Message[] = [{ severity: 'success', summary: 'Sucesso', detail: 'Cliente salvo' }]; 
  messagemVisivel: boolean = false;
  prioridades: SelectItem[] = [{label: 'SIM', value: 1}, {label: 'NÃO', value: 0}];
  dadosDre: string[] = ['CUSTOS FIXOS', 'CUSTOS VARIAVEIS', 'NÃO PRESENTE'];
  progressoRequisicao: boolean = false;
  mostrarDialogConta: boolean = false;
  modoImportacao: boolean = false;

  empresaSelecionada?: Empresa;
  @Input() empresa?: Empresa;
  @Output() emissor = new EventEmitter();
  planosContaGrupos: PlanoContaGrupo[] = [];
  listaContaMatriz: PlanoContaMatriz[] = [];
  codigoPlanoMatrizSelecionado?: number;

  constructor(private utilStorageService: UtilStorageService,
    private planoContaEmpresaService: PlanoContaEmpresaService,
    private planoContaGrupoService: PlanoContaGrupoService,
    private planoContaMatrizService: PlanoContaMatrizService,
    private erroService: ErroService) { }

  @ViewChild('f') form?: NgForm;
  value?: string;

  ngOnInit(): void {
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
    this.listarPlanosContaGrupos();
  }

  salvar(){
    this.progressoRequisicao =true;
    let planoContaEmpresa: PlanoContaEmpresa = this.form?.value;
    planoContaEmpresa.empresa = this.empresa;
    planoContaEmpresa.excluido = false;
    planoContaEmpresa.configuravel = true;
    if(this.modoImportacao){
      planoContaEmpresa.codigo = this.codigoPlanoMatrizSelecionado;
      this.planoContaEmpresaService.salvarImportado(planoContaEmpresa).subscribe({
        next: (data: PlanoContaEmpresa) => {
          this.progressoRequisicao = false;
          this.form?.reset();
          this.modoImportacao = false;
          this.messages = this.erroService.handleSuccess();
          this.messagemVisivel = true;
          this.rolarTela();
        },
        error: (err: any) => {
          this.progressoRequisicao = false;
          this.messages = this.erroService.handleErro(err);
          this.messagemVisivel = true;
          this.rolarTela();
        }
      });
    } else {
      this.planoContaEmpresaService.salvar(planoContaEmpresa).subscribe({
        next: (data: PlanoContaEmpresa) => {
          this.progressoRequisicao = false;
          this.form?.reset();
          this.messages = this.erroService.handleSuccess();
          this.messagemVisivel = true;
          this.rolarTela();
        },
        error: (err: any) => {
          this.progressoRequisicao = false;
          this.messages = this.erroService.handleErro(err);
          this.messagemVisivel = true;
          this.rolarTela();
        }
      });
    }

  }

  listarPlanosContaGrupos(){
    this.planoContaGrupoService.listarConfiguraveis().subscribe({
      next: (data: PlanoContaGrupo[]) => {
        this.planosContaGrupos = data;
      },
      error: (err: any) => {
        console.log(err);
      }
    })
  }

  carregarPlanosContaMatriz(){
    this.planoContaMatrizService.listarNaoUtilizadosPorEmpresa(this.empresa?.id).subscribe({
      next: (data: PlanoContaMatriz[]) => {
        this.listaContaMatriz = data;
      },
      error: (err: any) => {
        console.log(err);
      }
    })
  }

  importarConta(item: PlanoContaMatriz){
    console.log(item)
    this.form?.setValue({
      descricao: item.descricao,
      especificacao: item.especificacao,
      dre: item.dre,
      planoContaGrupo: item.planoContaGrupo
    });
    this.codigoPlanoMatrizSelecionado = item.id;
    this.modoImportacao = true;
    this.mostrarDialogConta = false;
  }

  abrirDialogConta(){
    this.mostrarDialogConta = true;
    this.carregarPlanosContaMatriz();
  }

  fecharDialogConta(){
    this.mostrarDialogConta = false;
  }

  voltar(){
    this.emissor.emit({modo: 'LISTAR'});
  }

  limparFormulario(){
    this.form?.reset(); 
  }

  rolarTela() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
  
}
